/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */

import React from "react";
import { StoryWrapper } from "../story-wrapper";

export const PhotoStory = props => {
  return <StoryWrapper {...props} />;
};

PhotoStory.defaultProps = {
  storyStoreField: "story",
  storyPageType: "photo-story"
};
export default PhotoStory;
